import { render, staticRenderFns } from "./renewals.vue?vue&type=template&id=06b5f43c&"
import script from "./renewals.vue?vue&type=script&lang=js&"
export * from "./renewals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports